export default __webpack_public_path__ + "static/media/twitch.f955d4b1.svg";